import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Optional, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { debounceTime } from 'rxjs/operators';
import { ReplaySubject, BehaviorSubject } from 'rxjs';
import { SubheaderService } from 'app/core/_base/layout';
import { LayoutUtilsService } from 'app/core/_base/crud';
import { CommonConFig } from 'app/core/_base/crud/models/common_config.model';
import moment from 'moment';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { FormBuilder, FormGroup } from '@angular/forms';
import { KhoXuatKhoPageDetailComponent } from '../../../chuc-nang-kho-page/kho-xuat-kho-page/kho-xuat-kho-page-detail/kho-xuat-kho-page-detail.component';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { SysConfigService } from '../../../cau-hinh/sys-config/sys-config-service/sys-config.service';
@Component({
	selector: 'm-dashboard-inventory-norm-config',
	templateUrl: './dashboard-inventory-norm-config.component.html',
	styleUrls: ['../dashboard-inventory-norms.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class DashboardInventoryNormConfigComponent implements OnInit {
	// .. Config
	CONFIG: CommonConFig;
	MESSAGE_ERROR = "Không thể tải danh sách thống kê tồn kho";
	title = "Cấu hình số lượng hàng tồn dưới định mức";
	// .........
	
	// ............
	// .. Async loading button
	loadingExport	= new BehaviorSubject<boolean>(false);
	loadingRunReport= new BehaviorSubject<boolean>(false);
	// .....................................
	// .. Filter
	down: any;
	top: any;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	preFilterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};
	isClearAll: boolean = false;
	
	form: FormGroup;
	// .....................................
	// .. Flag Load Product Dropdown
	loadDropdownProduct = new BehaviorSubject<boolean>(false);
	// .. Khai báo biến cho filter hàng hóa
	listIdHH: any[] = [];
	selectIdHH: string[] = [];
	filteredIdHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdHHFilterCtrl: string = '';
	haveElementIdHH: boolean = false;
	// .. Filter loại hàng hóa
	listLoaiHH: any[] = [];
	selectLoaiHH: string[] = [];
	filteredLoaiHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	LoaiHHFilterCtrl: string = '';
	haveElementLoaiHH: boolean = false;
	exporting = new BehaviorSubject<boolean>(false);
	
	// .. User Configuration
	userConfig: any = {};
	loadingUserConfig = new BehaviorSubject<boolean>(false);
	savingUserConfig = new BehaviorSubject<boolean>(false);
	// .....................................
	// .. Constructor
	constructor(
		@Optional() public dialogRef: MatDialogRef<DashboardInventoryNormConfigComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
		private service : SysConfigService,
		public  dialog : MatDialog,
		private route : ActivatedRoute,
		private router: Router,
		private formBuilder: FormBuilder,
		private subheaderService : SubheaderService,
		private changeDetect : ChangeDetectorRef,
		private commonService: DungChungService,
		private layoutUtilsService : LayoutUtilsService) {
			this.CONFIG = new CommonConFig();
			this.tmpfilterText = Object.assign({}, this.filterText);
			var user = JSON.parse(localStorage.getItem("UserInfo"));
        	var code = "2023062002";
			if (user.roles.findIndex(x => x == code) == -1)
				this.router.navigateByUrl("/");
		}
	// ......................................
	ngOnInit() {
		// .. Set title
		
		// .....................
		// .....................
		this.createForm();
		this.loadUserConfig();
		this.ListLoaiHH();
		// .....................
		this.form.get("ETListLoaiHH_inventory_norm").valueChanges
			.pipe(debounceTime(2000))
			.subscribe(value => this.ListIdHH());
	}
	handleAPIData(){
		const form = this.form.controls;
		const productIds = form["ETIdHH_inventory_norm"].value ? form["ETIdHH_inventory_norm"].value.map(x => Number(x)) : [];
		const productTypeIds = form["ETListLoaiHH_inventory_norm"].value ? form["ETListLoaiHH_inventory_norm"].value.map(x => Number(x)) : [];
		const outOfDate = form["ETOutDate"].value;

		this.loadingRunReport.next(true);
		
		// .................................
	}
	ngAfterViewInit() {}
	//Apply selected Column
	
	// .......................
	// .. Format Date
	getFormatDate(v: string = "") {
		if (v != "") {
			return v.includes("T")
				? v.replace(
					/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g,
					"$5/$3/$1"
				)
				: v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return "";
	}
	// .......................
	// .. Ép kiểu số
	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}
	// .......................
	
	// ...........................
	// .. Format string
	formatStr(obj){
		if (!obj) return "";
		return obj.trim().toString().toLowerCase().normalize("NFC");
	}
	formatDate(date){
		return  moment(date).format("DD/MM/YYYY");
	}
	// ...........................

	// ...........................
	// .. Lấy danh sách hàng hóa
	ListIdHH() {
		const form = this.form.controls;
		const productIds = form["ETIdHH_inventory_norm"].value ? form["ETIdHH_inventory_norm"].value.map(x => Number(x)) : [];
		const productTypeIds = form["ETListLoaiHH_inventory_norm"].value ? form["ETListLoaiHH_inventory_norm"].value.map(x => Number(x)) : [];
		this.loadDropdownProduct.next(true);
		this.commonService.getProductByMultiType(productTypeIds).subscribe(res => {
			if (res && res.status === 1) {
				this.listIdHH = res.data;
				this.filteredIdHH.next(this.listIdHH.slice());
				if (productIds.length > 0) {
					const selectedProduct = this.listIdHH
						.map(_x => _x.ProductId.toString())
						.filter(_x => productIds.map(p => p.toString()).indexOf(_x) > -1);
					form["ETIdHH_inventory_norm"].setValue(selectedProduct);
				}
				this.loadDropdownProduct.next(false);
				this.changeDetect.detectChanges();
			};
			this.loadDropdownProduct.next(false);
		});
	}
	// ...........................
	// .. Filter search text hàng hóa
	filterIdHH() {
		var search = this.IdHHFilterCtrl;
		if (!this.listIdHH) return;
		if (!search) {
			this.filteredIdHH.next(this.listIdHH.slice());
			return;
		}
		search = search.toLowerCase();
		this.filteredIdHH.next(
			this.listIdHH.filter(ts =>
				(ts.ProductCode + ' - ' + ts.ProductName).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	// ...........................
	// .. Xóa hàng hóa đã chọn từ mat-select
	ClearIdHH() {
		this.form.controls["ETIdHH_inventory_norm"].setValue([]);
	}
	// ...........................
	ListLoaiHH() {
		this.commonService.listLoaiHH().subscribe(res => {
			if (res && res.status === 1) {
				this.listLoaiHH = res.data;
				this.filteredLoaiHH.next(this.listLoaiHH.slice());
				this.changeDetect.detectChanges();
			};
		});
	}
	filterLoaiHH() {

		if (!this.listLoaiHH) {
			return;
		}
		// get the search keyword
		let search = this.LoaiHHFilterCtrl;
		if (!search) {
			this.filteredLoaiHH.next(this.listLoaiHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredLoaiHH.next(
			this.listLoaiHH.filter(ts =>
				ts.TenLoaiHH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	ClearLoaiHH() {
		this.form.controls["ETListLoaiHH_inventory_norm"].setValue([]);
	}
	// Form Group Filter
	createForm() {
		this.form = this.formBuilder.group({
			ETIdHH_inventory_norm: [],
			ETListLoaiHH_inventory_norm: [],
			ETSendMail_inventory_norm: false 
		});
		
	}
	// .................................
	onSubmit() {
		this.handleAPIData();
	}
	
	// .................................
	// .. Load User Configuration
	loadUserConfig() {
		this.loadingUserConfig.next(true);
		this.service.getUserConfig().subscribe(
			res => {
				if (res && res.status === 1 && res.data) {
					this.userConfig = res.data;
					this.applyUserConfig();
				}
				this.loadingUserConfig.next(false);
				this.ListIdHH();
				this.changeDetect.detectChanges();
			},
			error => {
				console.error('Error loading user config:', error);
				this.loadingUserConfig.next(false);
				this.ListIdHH();
				this.changeDetect.detectChanges();
			}
		);
	}
	
	// .. Apply User Configuration to Form
	applyUserConfig() {
		if (this.userConfig) {
			const form = this.form.controls;
			if (this.userConfig.find(x => x.ConfigKey === 'ETIdHH_inventory_norm')) {
				form["ETIdHH_inventory_norm"].setValue(JSON.parse(this.userConfig.find(x => x.ConfigKey === 'ETIdHH_inventory_norm').ConfigValue) || []);
			}
			if (this.userConfig.find(x => x.ConfigKey === 'ETListLoaiHH_inventory_norm')) {
				form["ETListLoaiHH_inventory_norm"].setValue(JSON.parse(this.userConfig.find(x => x.ConfigKey === 'ETListLoaiHH_inventory_norm').ConfigValue) || []);
			}
			if (this.userConfig.find(x => x.ConfigKey === 'ETSendMail_inventory_norm')) {
				form["ETSendMail_inventory_norm"].setValue(this.userConfig.find(x => x.ConfigKey === 'ETSendMail_inventory_norm').ConfigValue === 'true');
			}
		}
	}
	
	// .. Save User Configuration
	saveUserConfig() {
		const form = this.form.controls;
		const configsToSave = [];
		// Create configs for each setting
		configsToSave.push({
			ConfigKey: 'ETIdHH_inventory_norm',
			ConfigValue: JSON.stringify(form["ETIdHH_inventory_norm"].value || [])
		});
		configsToSave.push({
			ConfigKey: 'ETListLoaiHH_inventory_norm',
			ConfigValue: JSON.stringify(form["ETListLoaiHH_inventory_norm"].value || [])
		});
		
		configsToSave.push({
			ConfigKey: 'ETSendMail_inventory_norm',
			ConfigValue: form["ETSendMail_inventory_norm"].value ? 'true' : 'false'
		});

		this.savingUserConfig.next(true);
		this.service.updateUserConfig(configsToSave).subscribe(
			res => {
				if (res && res.status === 1) {
					//this.userConfig = configToSave;
					this.layoutUtilsService.showInfo('Lưu cấu hình thành công');
				} else {
					this.layoutUtilsService.showErorr('Lưu cấu hình thất bại');
				}
				this.savingUserConfig.next(false);
				this.onClose();
				this.changeDetect.detectChanges();
			},
			error => {
				console.error('Error saving user config:', error);
				this.layoutUtilsService.showErorr('Lưu cấu hình thất bại');
				this.savingUserConfig.next(false);
				this.changeDetect.detectChanges();
			}
		);
	}
	
	// .. Reset to Default Configuration
	resetUserConfig() {
		this.form.controls["ETIdHH_inventory_norm"].setValue([]);
		this.form.controls["ETListLoaiHH_inventory_norm"].setValue([]);
		this.form.controls["ETSendMail_inventory_norm"].setValue(false);
		this.saveUserConfig();
	}
    onClose() {
		//this.resetUserConfig();
		if (this.dialogRef) {
			this.dialogRef.close();
		}
	}
}
